import {CustomRendererProps, SingleSelectionProps, MonthDayCell, RangeSelectionProps, Year, CalendarView, DateRange, DayType} from './types';
import moment from 'moment/moment';
import {ReactNode} from 'react';
import { Year as WorkCalendarYear } from '../../../features/settings/workcalendar/types';

export const isRange = (obj: any): obj is RangeSelectionProps => {
    return obj != null && 'range' in obj;
}

export const isDefault = (obj: any): obj is SingleSelectionProps => {
    return obj != null && 'value' in obj;
}

export const isHasRenderer = (obj: any): obj is CustomRendererProps => {
    return obj != null && 'renderer' in obj;
}

export const formatDateRange = (first: moment.Moment, second: moment.Moment): DateRange => {
    const firstStamp = first.unix();
    const secondStamp = second.unix();
    
    if (firstStamp > secondStamp) {
        return [second, first];
    
    }
    return [first, second];
};

export const getMonth = (move?: number): { start: moment.Moment, end: moment.Moment } => {
    let today = moment();
    if (move) {
        today = today.add(move, 'month')
    }

    const start = today.startOf('month');
    const end = today.clone().endOf('month');

    return {
        start,
        end
    }
};

export const getDefaultMonthRange = (today: moment.Moment): { startDate: moment.Moment; endDate: moment.Moment } => ({
    startDate: today.clone().startOf('month'),
    endDate: today.clone().endOf('month')
});

export const getSelectedDateRangeFromFilter = (
    dateRangeFilter: { startDate?: string; endDate?: string } | undefined,
    defaults: { startDate: moment.Moment; endDate: moment.Moment }
): [moment.Moment, moment.Moment] => {
    const startDate = dateRangeFilter?.startDate
        ? moment(dateRangeFilter.startDate, 'YYYY-MM-DD')
        : defaults.startDate;
    const endDate = dateRangeFilter?.endDate
        ? moment(dateRangeFilter.endDate, 'YYYY-MM-DD')
        : defaults.endDate;
    return [startDate, endDate];
};

export const mapWorkCalendarYears = (years: WorkCalendarYear[]): Year[] => years.map((year) => ({
    id: year.year,
    months: year.months.map((month) => ({
        id: month.month,
        days: month.days.map((day) => ({
            id: day.day,
            type: (day.isShort ? 'short' : day.isHoliday ? 'off' : 'default') as DayType
        }))
    }))
}));

export const getWeek = (move?: number): { start: moment.Moment, end: moment.Moment } => {
    let today = moment();
    if (move) {
        today = today.add(move, 'week');
    }

    const start = today.startOf('week');
    const end = today.clone().endOf('week');

    return {
        start,
        end
    }
};

export const getQuarter = (move?: number): { start: moment.Moment, end: moment.Moment } => {
    let today = moment();
    if (move) {
        today = today.add(move, 'quarter')
    }

    const start = today.startOf('quarter'); 
    const end = today.clone().endOf('quarter');

    return {
        start,
        end
    }
};

export const getYear = (move?: number): { start: moment.Moment, end: moment.Moment } => {
    let today = moment();
    if (move) {
        today = today.add(move, 'year')
    }

    const start = today.startOf('year'); 
    const end = today.clone().endOf('year');

    return {
        start,
        end
    }
};


export const isMonthDayCellArray = (objs: MonthDayCell[] | ReactNode[]): objs is MonthDayCell[] => {
    return (<MonthDayCell[]>objs).some((x) => x.id !== undefined);
}

export const getSecondDate = (view: CalendarView, date: moment.Moment): moment.Moment => {
    switch (view) {
        case 'month': 
            return date.clone().add(1, 'month');
    }

    return date.clone();
}
